<template>
  <card-layout>
    <div slot="content">
      <div class="my-3 bold text-large">
        <i class="lock-icon mr-2"></i>
        <span>Access Denied</span>
      </div>
      <div>{{ message }}</div>
      <div class="text-secondary">Please contact the team admin for more info</div>
    </div>
  </card-layout>
</template>

<script>
/**
 * This is the view for a forbidden page
 * This will be rendered when users hits any page they don't have access to
 */
import CardLayout from '@/components/CardLayout'

export default {
  name: 'PageForbidden',
  components: {
    CardLayout
  },
  props: {
    message: {
      default: 'You do not have access to this page'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/styleConfigurations';

.lock-icon {
  @include dimension(18px, 18px);
  background-size: contain;
}
</style>
